import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const saleOrderBranchURL = `api/v1/sales-app/sales-order`;

//obtaining the paginated data
export const getSaleOrderBranch = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleOrderBranchURL}/list?ref_voucher=indent&${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllSaleOrderBranch = () =>
  axiosInstance.get(`${saleOrderBranchURL}/list?ref_voucher=indent&ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleOrderBranch = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${saleOrderBranchURL}/list?ref_voucher=indent&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );

export const getSaleOrderBranchAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?ref_voucher=indent&is_active=true`);

// get by id
export const getSaleOrderBranchById = (id) => axiosInstance.get(`${saleOrderBranchURL}/retrieve/${id}`);

//creating function
export const createSaleOrderBranch = (body) => axiosInstance.post(`${saleOrderBranchURL}/create`, body);
//updating function
export const updateSaleOrderBranch = (id, body) => axiosInstance.patch(`${saleOrderBranchURL}/update/${id}`, body);

//converting to Sale Invoice From Sales Order
export const convertToSaleInvoice = (body) => axiosInstance.post(`api/v1/sales-app/sales-invoice/branch/create`, body);

// api/v1/sales-app/sales-order

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleOrderBranchURL}/list?ref_voucher=indent&offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
